import { UploadedPolicyGetAllAdapter } from '../../../adapter';

export default async function UploadedPolicyGetAllUseCase(event) {
    const url = window.location.href;
    const isLocalhost = url.includes('localhost') || url.includes('hcc.dev.bpimsapps.com');
    const isUAT = url.includes('hcc.uat.bpimsapps.com');
    const isProd = url.includes('homeprotectionclaims.bpims.com');
    const [, stage, , flag] = url.split('.');

    // prepare data
    const endpoint = isLocalhost
        ? 'https://partners-api.dev.bpimsapps.com/policy/uploaded-policy/get-all'
        : isUAT
        ? 'https://partners-api.uat.bpimsapps.com/policy/uploaded-policy/get-all'
        : isProd
        ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/policy/uploaded-policy/get-all`
        : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
              flag ? '' : '/partners'
          }/policy/uploaded-policy/get-all`;

    // handle request
    const result = await UploadedPolicyGetAllAdapter(endpoint, JSON.stringify(event));

    return result;
}
